// import React, { useState, useEffect } from 'react';
// import { useSelector } from 'react-redux';
// import '../../Styles/ManagementPages.css';
// import '../../Styles/SeatManagement.css';
// import {
//   getAllSeatCategories,
//   getSeatCategoryById,
//   createSeatCategory,
//   updateSeatCategory,
//   deleteSeatCategory,
//   getAllSeatLayouts,
//   getSeatLayoutById,
//   createSeatLayout,
//   updateSeatLayout,
//   deleteSeatLayout,
//   previewSeatLayout,
//   getAvailableConfigurations,
// } from '../../Services/Operations/ProductAPI';

// const SkeletonStatsCard = () => (
//   <div className="stat-card skeleton">
//     <div className="skeleton-title"></div>
//     <div className="skeleton-value"></div>
//     <div className="skeleton-subtitle"></div>
//   </div>
// );

// const SkeletonTableRow = () => (
//   <tr className="skeleton-row">
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-badge"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-badge"></div></td>
//     <td><div className="skeleton-actions"></div></td>
//   </tr>
// );

// const SkeletonTable = () => (
//   <div className="table-container skeleton">
//     <table className="data-table">
//       <thead>
//         <tr>
//           <th>No.</th>
//           <th>Name</th>
//           <th>Configuration</th>
//           <th>Layouts</th>
//           <th>Status</th>
//           <th>Actions</th>
//         </tr>
//       </thead>
//       <tbody>
//         {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
//           <SkeletonTableRow key={i} />
//         ))}
//       </tbody>
//     </table>
//   </div>
// );

// const SkeletonModal = () => (
//   <div className="modal-overlay">
//     <div className="modal-content1 skeleton-modal">
//       <div className="modal-header">
//         <div className="skeleton-title"></div>
//         <div className="skeleton-close"></div>
//       </div>
//       <div className="modal-body">
//         <div className="skeleton-detail-header"></div>
//         <div className="skeleton-description"></div>
//         <div className="detail-grid">
//           {[1, 2, 3, 4, 5, 6].map((i) => (
//             <div key={i} className="skeleton-detail-item">
//               <div className="skeleton-label"></div>
//               <div className="skeleton-value"></div>
//             </div>
//           ))}
//         </div>
//       </div>
//       <div className="modal-footer">
//         <div className="skeleton-button"></div>
//       </div>
//     </div>
//   </div>
// );

// const SkeletonFormModal = () => (
//   <div className="modal-overlay">
//     <div className="modal-content1 skeleton-modal">
//       <div className="modal-header">
//         <div className="skeleton-title"></div>
//         <div className="skeleton-close"></div>
//       </div>
//       <div className="modal-body">
//         {[1, 2, 3, 4].map((i) => (
//           <div key={i} className="form-group">
//             <div className="skeleton-label"></div>
//             <div className="skeleton-input"></div>
//           </div>
//         ))}
//       </div>
//       <div className="modal-footer">
//         <div className="skeleton-button"></div>
//         <div className="skeleton-button"></div>
//       </div>
//     </div>
//   </div>
// );

// const SeatManagement = () => {
//   const { token } = useSelector(state => state.user);
//   const [activeTab, setActiveTab] = useState('categories');
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [searching, setSearching] = useState(false);

//   const [categories, setCategories] = useState([]);
//   const [showCategoryModal, setShowCategoryModal] = useState(false);
//   const [editingCategory, setEditingCategory] = useState(null);
//   const [categoryForm, setCategoryForm] = useState({
//     name: '',
//     description: '',
//     configuration: ''
//   });
//   const [categoryError, setCategoryError] = useState(null);

//   const [layouts, setLayouts] = useState([]);
//   const [showLayoutModal, setShowLayoutModal] = useState(false);
//   const [editingLayout, setEditingLayout] = useState(null);
//   const [layoutForm, setLayoutForm] = useState({
//     name: '',
//     description: '',
//     category: '',
//     seatType: 'seat',
//     rows: 1
//   });
//   const [layoutError, setLayoutError] = useState(null);
//   const [layoutPreview, setLayoutPreview] = useState(null);
//   const [loadingPreview, setLoadingPreview] = useState(false);
//   const [availableConfigurations, setAvailableConfigurations] = useState([]);

//   const [viewingCategory, setViewingCategory] = useState(null);
//   const [viewingLayout, setViewingLayout] = useState(null);
//   const [viewLoading, setViewLoading] = useState(false);

//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [totalItems, setTotalItems] = useState(0);
//   const [pageSize] = useState(10);

//   const safeText = (value, fallback = 'N/A') => {
//     if (value === null || value === undefined || value === '') {
//       return fallback;
//     }
//     if (typeof value === 'object') {
//       if (value.name) return value.name;
//       return JSON.stringify(value);
//     }
//     return String(value);
//   };

//   useEffect(() => {
//     if (activeTab === 'categories') {
//       fetchCategories();
//     } else {
//       fetchLayouts();
//     }
//   }, [currentPage, searchTerm, activeTab]);

//   useEffect(() => {
//     fetchConfigurations();
//   }, []);

//   const fetchConfigurations = async () => {
//     try {
//       const response = await getAvailableConfigurations(token);
//       if (response.success) {
//         setAvailableConfigurations(response.data || []);
//       }
//     } catch (error) {
//       console.error('Error fetching configurations:', error);
//     }
//   };

//   const fetchCategories = async () => {
//     try {
//       setSearching(true);
//       setLoading(true);
//       const response = await getAllSeatCategories(token, currentPage, pageSize, searchTerm);

//       if (response && response.data) {
//         const transformedCategories = response.data.map((category, index) => ({
//           id: String(category._id || ''),
//           serialNo: (currentPage - 1) * pageSize + index + 1,
//           name: String(category.name || ''),
//           description: String(category.description || ''),
//           configuration: String(category.configuration || ''),
//           leftSeats: Number(category.leftSeats || 0),
//           rightSeats: Number(category.rightSeats || 0),
//           totalSeatsPerRow: Number(category.totalSeatsPerRow || 0),
//           layoutCount: Number(category.layoutCount || 0),
//           isActive: Boolean(category.isActive || false),
//           rawData: category
//         }));

//         setCategories(transformedCategories);
//         setTotalPages(response.totalPages || 1);
//         setTotalItems(response.total || transformedCategories.length);
//       }
//     } catch (error) {
//       console.error('Error fetching categories:', error);
//     } finally {
//       setLoading(false);
//       setSearching(false);
//     }
//   };

//   const fetchLayouts = async () => {
//     try {
//       setSearching(true);
//       setLoading(true);
//       const response = await getAllSeatLayouts(token, currentPage, pageSize, searchTerm);

//       if (response && response.data) {
//         const transformedLayouts = response.data.map((layout, index) => {
//           let categoryName = 'Unknown';
//           let categoryId = '';

//           if (layout.category) {
//             if (typeof layout.category === 'object') {
//               categoryName = String(layout.category.name || 'Unknown');
//               categoryId = layout.category._id || '';
//             } else {
//               categoryName = String(layout.category);
//               categoryId = String(layout.category || '');
//             }
//           }

//           return {
//             id: String(layout._id || ''),
//             serialNo: (currentPage - 1) * pageSize + index + 1,
//             name: String(layout.name || ''),
//             description: String(layout.description || ''),
//             category: categoryName,
//             categoryId: categoryId,
//             configuration: String(layout.configuration || ''),
//             seatType: String(layout.seatType || 'seat'),
//             rows: Number(layout.rows || 0),
//             totalSeats: Number(layout.totalSeats || 0),
//             isActive: Boolean(layout.isActive || false),
//             rawData: layout
//           };
//         });

//         setLayouts(transformedLayouts);
//         setTotalPages(response.totalPages || 1);
//         setTotalItems(response.total || transformedLayouts.length);
//       }
//     } catch (error) {
//       console.error('Error fetching layouts:', error);
//     } finally {
//       setLoading(false);
//       setSearching(false);
//     }
//   };

//   const handleViewCategory = async (category) => {
//     try {
//       setViewLoading(true);
//       const response = await getSeatCategoryById(category.id, token);

//       if (response.success) {
//         setViewingCategory(response.data);
//       } else {
//         setViewingCategory(category.rawData || category);
//       }
//     } catch (error) {
//       console.error('Error viewing category:', error);
//       setViewingCategory(category.rawData || category);
//     } finally {
//       setViewLoading(false);
//     }
//   };

//   const handleViewLayout = async (layout) => {
//     try {
//       setViewLoading(true);
//       const response = await getSeatLayoutById(layout.id, token);

//       if (response.success) {
//         setViewingLayout(response.data);
//       } else {
//         setViewingLayout(layout.rawData || layout);
//       }
//     } catch (error) {
//       console.error('Error viewing layout:', error);
//       setViewingLayout(layout.rawData || layout);
//     } finally {
//       setViewLoading(false);
//     }
//   };

//   const handleCreateCategory = (e) => {
//     if (e) e.stopPropagation();
//     setEditingCategory(null);
//     setCategoryForm({ name: '', description: '', configuration: '' });
//     setCategoryError(null);
//     setShowCategoryModal(true);
//   };

//   const handleEditCategory = (category, e) => {
//     if (e) e.stopPropagation();
//     setEditingCategory(category.id);
//     setCategoryForm({
//       name: String(category.name || ''),
//       description: String(category.description || ''),
//       configuration: String(category.configuration || '')
//     });
//     setCategoryError(null);
//     setShowCategoryModal(true);
//   };

//   const handleSaveCategory = async () => {
//     try {
//       setCategoryError(null);

//       if (!categoryForm.name || !categoryForm.description || !categoryForm.configuration) {
//         setCategoryError('All fields are required');
//         return;
//       }

//       if (editingCategory) {
//         const response = await updateSeatCategory(editingCategory, categoryForm, token);
//         if (response.success) {
//           await fetchCategories();
//           setShowCategoryModal(false);
//           alert('Category updated successfully!');
//         } else {
//           setCategoryError(response.message || 'Failed to update category');
//         }
//       } else {
//         const response = await createSeatCategory(categoryForm, token);
//         if (response.success) {
//           await fetchCategories();
//           setShowCategoryModal(false);
//           alert('Category created successfully!');
//         } else {
//           setCategoryError(response.message || 'Failed to create category');
//         }
//       }
//     } catch (error) {
//       console.error('Error saving category:', error);
//       setCategoryError(error.message || 'An error occurred');
//     }
//   };

//   const handleDeleteCategory = async (id) => {
//     if (window.confirm('Are you sure you want to delete this category?')) {
//       try {
//         const response = await deleteSeatCategory(id, token);
//         if (response.success) {
//           await fetchCategories();
//           alert('Category deleted successfully!');
//         } else {
//           alert(response.message || 'Failed to delete category');
//         }
//       } catch (error) {
//         console.error('Error deleting category:', error);
//         alert('Error deleting category');
//       }
//     }
//   };

//   const handleCreateLayout = (e) => {
//     if (e) e.stopPropagation();
//     setEditingLayout(null);
//     setLayoutForm({
//       name: '',
//       description: '',
//       category: '',
//       seatType: 'seat',
//       rows: 1
//     });
//     setLayoutError(null);
//     setLayoutPreview(null);
//     setShowLayoutModal(true);
//   };

//   const handleEditLayout = (layout, e) => {
//     if (e) e.stopPropagation();
//     setEditingLayout(layout.id);
//     setLayoutForm({
//       name: String(layout.name || ''),
//       description: String(layout.description || ''),
//       category: String(layout.categoryId || ''),
//       seatType: String(layout.seatType || 'seat'),
//       rows: Number(layout.rows || 1)
//     });
//     setLayoutError(null);
//     setLayoutPreview(null);
//     setShowLayoutModal(true);
//   };

//   const handleGeneratePreview = async () => {
//     try {
//       if (!layoutForm.category || !layoutForm.seatType || layoutForm.rows < 1) {
//         setLayoutError('Please fill all required fields');
//         return;
//       }

//       setLoadingPreview(true);
//       const previewData = {
//         category: layoutForm.category,
//         seatType: layoutForm.seatType,
//         rows: parseInt(layoutForm.rows),
//         basePrice: 1200
//       };

//       const response = await previewSeatLayout(previewData, token);
//       if (response.success) {
//         setLayoutPreview(response.data);
//       } else {
//         setLayoutError(response.message || 'Failed to generate preview');
//       }
//     } catch (error) {
//       setLayoutError(error.message || 'Error generating preview');
//     } finally {
//       setLoadingPreview(false);
//     }
//   };

//   const handleSaveLayout = async () => {
//     try {
//       setLayoutError(null);

//       if (!layoutPreview) {
//         setLayoutError('Please generate a preview first');
//         return;
//       }

//       if (!layoutForm.name || !layoutForm.description) {
//         setLayoutError('Name and description are required');
//         return;
//       }

//       const layoutData = {
//         name: layoutForm.name,
//         description: layoutForm.description,
//         category: layoutForm.category,
//         seatType: layoutForm.seatType,
//         rows: parseInt(layoutForm.rows)
//       };

//       if (editingLayout) {
//         const response = await updateSeatLayout(editingLayout, layoutData, token);
//         if (response.success) {
//           await fetchLayouts();
//           setShowLayoutModal(false);
//           alert('Layout updated successfully!');
//         } else {
//           setLayoutError(response.message || 'Failed to update layout');
//         }
//       } else {
//         const response = await createSeatLayout(layoutData, token);
//         if (response.success) {
//           await fetchLayouts();
//           setShowLayoutModal(false);
//           alert('Layout created successfully!');
//         } else {
//           setLayoutError(response.message || 'Failed to create layout');
//         }
//       }
//     } catch (error) {
//       console.error('Error saving layout:', error);
//       setLayoutError(error.message || 'An error occurred');
//     }
//   };

//   const handleDeleteLayout = async (id) => {
//     if (window.confirm('Are you sure you want to delete this layout?')) {
//       try {
//         const response = await deleteSeatLayout(id, token);
//         if (response.success) {
//           await fetchLayouts();
//           alert('Layout deleted successfully!');
//         } else {
//           alert(response.message || 'Failed to delete layout');
//         }
//       } catch (error) {
//         console.error('Error deleting layout:', error);
//         alert('Error deleting layout');
//       }
//     }
//   };

//   const handleSearchChange = (e) => {
//     setSearchTerm(e.target.value);
//     setCurrentPage(1);
//   };

//   const handleRefresh = () => {
//     setCurrentPage(1);
//     if (activeTab === 'categories') {
//       fetchCategories();
//     } else {
//       fetchLayouts();
//     }
//   };

//   const handlePrevPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage(prev => prev - 1);
//     }
//   };

//   const handleNextPage = () => {
//     if (currentPage < totalPages) {
//       setCurrentPage(prev => prev + 1);
//     }
//   };

//   const handlePageClick = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   const handleExportCSV = () => {
//     const data = activeTab === 'categories' ? categories : layouts;
//     if (data.length === 0) {
//       alert('No data to export');
//       return;
//     }

//     let headers, csvData;

//     if (activeTab === 'categories') {
//       headers = ['No.', 'Name', 'Configuration', 'Left Seats', 'Right Seats', 'Total/Row', 'Layouts', 'Status'];
//       csvData = data.map(item => [
//         item.serialNo,
//         item.name,
//         item.configuration,
//         item.leftSeats,
//         item.rightSeats,
//         item.totalSeatsPerRow,
//         item.layoutCount,
//         item.isActive ? 'Active' : 'Inactive'
//       ]);
//     } else {
//       headers = ['No.', 'Name', 'Category', 'Seat Type', 'Configuration', 'Rows', 'Total Seats', 'Status'];
//       csvData = data.map(item => [
//         item.serialNo,
//         item.name,
//         item.category,
//         item.seatType,
//         item.configuration,
//         item.rows,
//         item.totalSeats,
//         item.isActive ? 'Active' : 'Inactive'
//       ]);
//     }

//     const csvContent = [
//       headers.join(','),
//       ...csvData.map(row => row.map(field => `"${field}"`).join(','))
//     ].join('\n');

//     const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
//     const url = window.URL.createObjectURL(blob);
//     const link = document.createElement('a');
//     link.href = url;
//     link.download = `${activeTab}-report-${new Date().toISOString().split('T')[0]}.csv`;
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//     window.URL.revokeObjectURL(url);

//     alert('CSV exported successfully!');
//   };

//   const renderSeatPreview = () => {
//     if (!layoutPreview || !layoutPreview.seatPreview) return null;

//     const { seatPreview, totalRows, seatsPerRow, configuration, totalSeats, backSeats } = layoutPreview;

//     const seatsByRow = {};
//     seatPreview.forEach(seat => {
//       if (!seatsByRow[seat.row]) {
//         seatsByRow[seat.row] = [];
//       }
//       seatsByRow[seat.row].push(seat);
//     });

//     const sortedRows = Object.keys(seatsByRow).sort((a, b) => Number(a) - Number(b));
//     const [leftCount, rightCount] = configuration.split('*').map(Number);

//     return (
//       <div className="preview-container">
//         <h4>Seat Layout Preview</h4>
//         <div className="seat-preview-grid">
//           {sortedRows.map(rowNum => {
//             const isBackRow = rowNum > totalRows - (backSeats / seatsPerRow);
//             const rowSeats = seatsByRow[rowNum].sort((a, b) => a.column - b.column);
//             const leftSeats = rowSeats.filter(seat => seat.position === 'left');
//             const rightSeats = rowSeats.filter(seat => seat.position === 'right' || seat.position === 'middle');

//             return (
//               <div key={rowNum} className={`preview-row ${isBackRow ? 'back-row' : ''}`}>
//                 <div className="row-label">{isBackRow ? 'Back Row' : `Row ${rowNum}`}</div>
//                 <div className="row-seats">
//                   <div className="seat-group left-group">
//                     {leftSeats.map(seat => (
//                       <div key={seat.seatNumber} className="preview-seat left" title={`${seat.seatNumber} - Left`}>
//                         <span className="seat-number">{seat.seatNumber}</span>
//                       </div>
//                     ))}
//                   </div>
//                   <div className="aisle-space">
//                     <span className="aisle-label">Aisle</span>
//                   </div>
//                   <div className="seat-group right-group">
//                     {rightSeats.map(seat => (
//                       <div key={seat.seatNumber} className="preview-seat right" title={`${seat.seatNumber} - Right`}>
//                         <span className="seat-number">{seat.seatNumber}</span>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//                 <div className="row-summary">
//                   <span className="left-count">{leftSeats.length}L</span>
//                   <span className="right-count">{rightSeats.length}R</span>
//                 </div>
//               </div>
//             );
//           })}
//         </div>
//         <div className="preview-legend">
//           <div className="legend-item">
//             <div className="legend-color left-seat"></div>
//             <span>Left Seat ({leftCount} per row)</span>
//           </div>
//           <div className="legend-item">
//             <div className="legend-color right-seat"></div>
//             <span>Right Seat ({rightCount} per row)</span>
//           </div>
//           <div className="legend-item">
//             <div className="legend-color back-seat"></div>
//             <span>Back Row Seats</span>
//           </div>
//           <div className="legend-item">
//             <div className="legend-color aisle"></div>
//             <span>Aisle (Center)</span>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   if (loading && (activeTab === 'categories' ? categories.length === 0 : layouts.length === 0)) {
//     return (
//       <div className="management-page">
//         <div className="page-header">
//           <div className="skeleton-header-title"></div>
//           <div className="header-actions">
//             <div className="skeleton-search"></div>
//             <div className="skeleton-button"></div>
//             <div className="skeleton-button"></div>
//           </div>
//         </div>

//         <div className="tabs-container">
//           <div className="tabs">
//             <div className="skeleton-tab"></div>
//             <div className="skeleton-tab"></div>
//           </div>
//           <div className="skeleton-create-btn"></div>
//         </div>

//         <div className="stats-cards">
//           {[1, 2, 3, 4].map((i) => (
//             <SkeletonStatsCard key={i} />
//           ))}
//         </div>

//         <SkeletonTable />

//         <div className="pagination-container">
//           <div className="skeleton-pagination-info"></div>
//           <div className="skeleton-pagination-controls"></div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="management-page">
//       <div className="page-header">
//         <h1>Seat Management</h1>
//         <div className="header-actions">
//           <div style={{ position: 'relative' }}>
//             <input
//               type="text"
//               placeholder={`Search ${activeTab}...`}
//               className="search-input"
//               value={searchTerm}
//               onChange={handleSearchChange}
//               style={{ width: "300px" }}
//             />
//             {searching && (
//               <span style={{
//                 position: 'absolute', right: '10px', top: '50%',
//                 transform: 'translateY(-50%)', fontSize: '12px', color: '#888'
//               }}>
//                 searching...
//               </span>
//             )}
//           </div>
//           <button className="refresh-btn" onClick={handleRefresh}>
//             Refresh
//           </button>
//           <button className="export-btn" onClick={handleExportCSV}>
//             Export CSV
//           </button>
//         </div>
//       </div>


//       <div className="tabs-container">
//         <div className="tabs">
//           <button
//             className={`tab-btn ${activeTab === 'categories' ? 'active' : ''}`}
//             onClick={() => setActiveTab('categories')}
//           >
//             Seat Categories
//           </button>
//           <button
//             className={`tab-btn ${activeTab === 'layouts' ? 'active' : ''}`}
//             onClick={() => setActiveTab('layouts')}
//           >
//             Seat Layouts
//           </button>
//         </div>

//         <div className="tab-actions">
//           <button
//             className="create-btn"
//             onClick={activeTab === 'categories' ? handleCreateCategory : handleCreateLayout}
//           >
//             + Create New {activeTab === 'categories' ? 'Category' : 'Layout'}
//           </button>
//         </div>
//       </div>


//       <div className="stats-cards">
//         <div className="stat-card">
//           <h3>Total {activeTab === 'categories' ? 'Categories' : 'Layouts'}</h3>
//           <p>{totalItems}</p>
//           <span>All {activeTab} in system</span>
//         </div>

//         {activeTab === 'categories' ? (
//           <>
//             <div className="stat-card">
//               <h3>Active Categories</h3>
//               <p>{categories.filter(c => c.isActive).length}</p>
//               <span>Currently active</span>
//             </div>
//             <div className="stat-card">
//               <h3>Total Layouts</h3>
//               <p>{categories.reduce((sum, cat) => sum + (cat.layoutCount || 0), 0)}</p>
//               <span>Across all categories</span>
//             </div>
//             <div className="stat-card">
//               <h3>Search Results</h3>
//               <p>{categories.length}</p>
//               <span>{activeTab} found</span>
//             </div>
//           </>
//         ) : (
//           <>
//             <div className="stat-card">
//               <h3>Active Layouts</h3>
//               <p>{layouts.filter(l => l.isActive).length}</p>
//               <span>Currently active</span>
//             </div>
//             <div className="stat-card">
//               <h3>Seat Types</h3>
//               <p>{[...new Set(layouts.map(l => l.seatType))].length}</p>
//               <span>Different seat types</span>
//             </div>
//             <div className="stat-card">
//               <h3>Total Seats</h3>
//               <p>{layouts.reduce((sum, layout) => sum + (layout.totalSeats || 0), 0)}</p>
//               <span>Across all layouts</span>
//             </div>
//           </>
//         )}
//       </div>


//       <div className="table-container">
//         {activeTab === 'categories' ? (
//           <table className="data-table">
//             <thead>
//               <tr>
//                 <th>No.</th>
//                 <th>Name</th>
//                 <th>Configuration</th>
//                 <th>Layouts</th>
//                 <th>Status</th>
//                 <th>Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {categories.length > 0 ? (
//                 categories.map(category => (
//                   <tr key={category.id}>
//                     <td>{category.serialNo}</td>
//                     <td>
//                       <div className="category-name">
//                         <strong>{category.name}</strong>
//                         <small>{category.description}</small>
//                       </div>
//                     </td>
//                     <td>
//                       <span className="config-badge">{category.configuration}</span>
//                     </td>
//                     <td>{category.layoutCount}</td>
//                     <td>
//                       <span className={`status-badge ${category.isActive ? 'active' : 'inactive'}`}>
//                         {category.isActive ? 'Active' : 'Inactive'}
//                       </span>
//                     </td>
//                     <td>
//                       <div className="action-buttons">
//                         <button className="action-btn view" onClick={() => handleViewCategory(category)} disabled={viewLoading}>
//                           {viewLoading && viewingCategory?.id === category.id ? 'Loading...' : 'View'}
//                         </button>
//                         <button className="action-btn edit" onClick={(e) => handleEditCategory(category, e)}>Edit</button>
//                         <button className="action-btn delete" onClick={() => handleDeleteCategory(category.id)}>Delete</button>
//                       </div>
//                     </td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr><td colSpan="6" className="no-data"><p>No categories found {searchTerm ? 'matching your search' : ''}.</p>{searchTerm && (<button className="clear-filters-link" onClick={() => { setSearchTerm(''); setCurrentPage(1); }}>Clear search</button>)}</td></tr>
//               )}
//             </tbody>
//           </table>
//         ) : (
//           <table className="data-table">
//             <thead>
//               <tr>
//                 <th>No.</th>
//                 <th>Name</th>
//                 <th>Category</th>
//                 <th>Seat Type</th>
//                 <th>Total Seats</th>
//                 <th>Status</th>
//                 <th>Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {layouts.length > 0 ? (
//                 layouts.map(layout => (
//                   <tr key={layout.id}>
//                     <td>{layout.serialNo}</td>
//                     <td>
//                       <div className="layout-name">
//                         <strong>{layout.name}</strong>
//                         <small>{layout.description}</small>
//                       </div>
//                     </td>
//                     <td>{layout.category}</td>
//                     <td>
//                       <span className={`seat-type-badge ${layout.seatType}`}>{layout.seatType}</span>
//                     </td>
//                     <td>{layout.totalSeats}</td>
//                     <td>
//                       <span className={`status-badge ${layout.isActive ? 'active' : 'inactive'}`}>
//                         {layout.isActive ? 'Active' : 'Inactive'}
//                       </span>
//                     </td>
//                     <td>
//                       <div className="action-buttons">
//                         <button className="action-btn view" onClick={() => handleViewLayout(layout)} disabled={viewLoading}>
//                           {viewLoading && viewingLayout?.id === layout.id ? 'Loading...' : 'View'}
//                         </button>
//                         <button className="action-btn edit" onClick={(e) => handleEditLayout(layout, e)}>Edit</button>
//                         <button className="action-btn delete" onClick={() => handleDeleteLayout(layout.id)}>Delete</button>
//                       </div>
//                     </td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr><td colSpan="7" className="no-data"><p>No layouts found {searchTerm ? 'matching your search' : ''}.</p>{searchTerm && (<button className="clear-filters-link" onClick={() => { setSearchTerm(''); setCurrentPage(1); }}>Clear search</button>)}</td></tr>
//               )}
//             </tbody>
//           </table>
//         )}

//         {(activeTab === 'categories' ? categories.length : layouts.length) === 0 && !loading && (
//           <div className="no-data">
//             <p>No {activeTab} found matching your search.</p>
//           </div>
//         )}
//       </div>


//       <div className="pagination-container">
//         <div className="pagination-info">
//           Showing {(activeTab === 'categories' ? categories.length : layouts.length)} of {totalItems} {activeTab}
//           (Page {currentPage} of {totalPages})
//           {searchTerm && <span className="filtered-indicator"> • Search: "{searchTerm}"</span>}
//         </div>
//         <div className="pagination-controls">
//           <button className="pagination-btn" onClick={handlePrevPage} disabled={currentPage === 1}>Previous</button>
//           <div className="page-numbers">
//             {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
//               let pageNumber;
//               if (totalPages <= 5) pageNumber = i + 1;
//               else if (currentPage <= 3) pageNumber = i + 1;
//               else if (currentPage >= totalPages - 2) pageNumber = totalPages - 4 + i;
//               else pageNumber = currentPage - 2 + i;
//               return (<button key={pageNumber} className={`page-number ${pageNumber === currentPage ? 'active' : ''}`} onClick={() => handlePageClick(pageNumber)}>{pageNumber}</button>);
//             })}
//           </div>
//           <button className="pagination-btn" onClick={handleNextPage} disabled={currentPage === totalPages}>Next</button>
//         </div>
//       </div>


//       {showCategoryModal && (
//         <div className="modal-overlay" onClick={() => setShowCategoryModal(false)}>
//           <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>{editingCategory ? 'Edit Category' : 'Create New Category'}</h3>
//               <button className="modal-close-btn" onClick={() => setShowCategoryModal(false)}>×</button>
//             </div>
//             <div className="modal-body">
//               {categoryError && <div className="error-message">{categoryError}</div>}
//               <div className="form-group">
//                 <label>Category Name *</label>
//                 <input type="text" value={categoryForm.name} onChange={(e) => setCategoryForm({ ...categoryForm, name: e.target.value })} placeholder="e.g., Standard 2x2 Layout" className="form-input" />
//               </div>
//               <div className="form-group">
//                 <label>Description *</label>
//                 <textarea value={categoryForm.description} onChange={(e) => setCategoryForm({ ...categoryForm, description: e.target.value })} placeholder="Describe this seat configuration" className="form-input" rows="3" />
//               </div>
//               <div className="form-group">
//                 <label>Configuration *</label>
//                 <input type="text" value={categoryForm.configuration} onChange={(e) => setCategoryForm({ ...categoryForm, configuration: e.target.value })} placeholder="e.g., 2*2, 3*2, 4*3" className="form-input" />
//                 <small className="form-hint">Format: leftSeats*rightSeats</small>
//               </div>
//             </div>
//             <div className="modal-footer">
//               <button className="modal-btn cancel" onClick={() => setShowCategoryModal(false)}>Cancel</button>
//               <button className="modal-btn save" onClick={handleSaveCategory}>{editingCategory ? 'Update' : 'Create'} Category</button>
//             </div>
//           </div>
//         </div>
//       )}


//       {showLayoutModal && (
//         <div className="modal-overlay" onClick={() => setShowLayoutModal(false)}>
//           <div className="modal-content1 modal-lg" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>{editingLayout ? 'Edit Layout' : 'Create New Layout'}</h3>
//               <button className="modal-close-btn" onClick={() => setShowLayoutModal(false)}>×</button>
//             </div>
//             <div className="modal-body">
//               {layoutError && <div className="error-message">{layoutError}</div>}
//               <div className="form-row">
//                 <div className="form-group">
//                   <label>Layout Name *</label>
//                   <input type="text" value={layoutForm.name} onChange={(e) => setLayoutForm({ ...layoutForm, name: e.target.value })} placeholder="e.g., Economy 2x2 Bus" className="form-input" />
//                 </div>
//                 <div className="form-group">
//                   <label>Description *</label>
//                   <input type="text" value={layoutForm.description} onChange={(e) => setLayoutForm({ ...layoutForm, description: e.target.value })} placeholder="e.g., Economy class with regular seats" className="form-input" />
//                 </div>
//               </div>
//               <div className="form-row">
//                 <div className="form-group">
//                   <label>Category *</label>
//                   <select value={layoutForm.category} onChange={(e) => setLayoutForm({ ...layoutForm, category: e.target.value })} className="form-input">
//                     <option value="">Select Category</option>
//                     {categories.map(cat => (<option key={cat.id} value={cat.id}>{cat.name} ({cat.configuration})</option>))}
//                   </select>
//                 </div>
//                 <div className="form-group">
//                   <label>Seat Type *</label>
//                   <select value={layoutForm.seatType} onChange={(e) => setLayoutForm({ ...layoutForm, seatType: e.target.value })} className="form-input">
//                     <option value="seat">Regular Seat</option>
//                     <option value="sleeper">Sleeper</option>
//                     <option value="seater+sleeper">Seat + Sleeper</option>
//                   </select>
//                 </div>
//               </div>
//               <div className="form-row">
//                 <div className="form-group">
//                   <label>Number of Rows *</label>
//                   <input type="number" value={layoutForm.rows} onChange={(e) => setLayoutForm({ ...layoutForm, rows: parseInt(e.target.value) || 1 })} min="1" className="form-input" />
//                 </div>
//               </div>
//               <div className="form-actions">
//                 <button className="preview-btn" onClick={handleGeneratePreview} disabled={loadingPreview || !layoutForm.category || !layoutForm.seatType}>
//                   {loadingPreview ? 'Generating...' : 'Generate Preview'}
//                 </button>
//               </div>
//               {layoutPreview && renderSeatPreview()}
//             </div>
//             <div className="modal-footer">
//               <button className="modal-btn cancel" onClick={() => setShowLayoutModal(false)}>Cancel</button>
//               <button className="modal-btn save" onClick={handleSaveLayout} disabled={!layoutPreview}>
//                 {editingLayout ? 'Update' : 'Create'} Layout
//               </button>
//             </div>
//           </div>
//         </div>
//       )}


//       {viewingCategory && (
//         <div className="modal-overlay" onClick={() => setViewingCategory(null)}>
//           <div className="modal-content1 modal-lg" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Category Details</h3>
//               <button className="modal-close-btn" onClick={() => setViewingCategory(null)}>×</button>
//             </div>
//             <div className="modal-body">
//               {viewLoading ? (
//                 <div className="loading-container"><p>Loading category details...</p></div>
//               ) : (
//                 <div className="category-details">
//                   <div className="detail-header">
//                     <h4>{safeText(viewingCategory.name)}</h4>
//                     <span className={`status-badge ${viewingCategory.isActive ? 'active' : 'inactive'}`}>
//                       {viewingCategory.isActive ? 'Active' : 'Inactive'}
//                     </span>
//                   </div>
//                   <p className="description">{safeText(viewingCategory.description)}</p>
//                   <div className="detail-grid">
//                     <div className="detail-item"><label>Configuration:</label><span className="config-value">{safeText(viewingCategory.configuration)}</span></div>
//                     <div className="detail-item"><label>Left Seats:</label><span>{viewingCategory.leftSeats || 0}</span></div>
//                     <div className="detail-item"><label>Right Seats:</label><span>{viewingCategory.rightSeats || 0}</span></div>
//                     <div className="detail-item"><label>Total per Row:</label><span>{viewingCategory.totalSeatsPerRow || 0}</span></div>
//                     <div className="detail-item"><label>Layout Count:</label><span>{viewingCategory.layoutCount || 0}</span></div>
//                     <div className="detail-item"><label>Available Seat Types:</label><span>{viewingCategory.availableSeatTypes && Array.isArray(viewingCategory.availableSeatTypes) ? viewingCategory.availableSeatTypes.join(', ') : 'N/A'}</span></div>
//                     {viewingCategory.createdAt && (<div className="detail-item"><label>Created At:</label><span>{new Date(viewingCategory.createdAt).toLocaleDateString()}</span></div>)}
//                     {viewingCategory.updatedAt && (<div className="detail-item"><label>Updated At:</label><span>{new Date(viewingCategory.updatedAt).toLocaleDateString()}</span></div>)}
//                   </div>
//                   {viewingCategory.configuration && (
//                     <div className="config-preview-section">
//                       <h5>Configuration Details:</h5>
//                       <div className="seat-visualization">
//                         <div className="seat-row">
//                           {Array.from({ length: viewingCategory.leftSeats || 0 }).map((_, i) => (<div key={`left-${i}`} className="seat left">L{i + 1}</div>))}
//                           <div className="aisle">Aisle</div>
//                           {Array.from({ length: viewingCategory.rightSeats || 0 }).map((_, i) => (<div key={`right-${i}`} className="seat right">R{i + 1}</div>))}
//                         </div>
//                         <div className="visual-info"><p>Left Seats: {viewingCategory.leftSeats || 0}</p><p>Right Seats: {viewingCategory.rightSeats || 0}</p><p>Total per Row: {viewingCategory.totalSeatsPerRow || 0}</p></div>
//                       </div>
//                     </div>
//                   )}
//                 </div>
//               )}
//             </div>
//             <div className="modal-footer">
//               <button className="modal-btn close" onClick={() => setViewingCategory(null)}>Close</button>
//             </div>
//           </div>
//         </div>
//       )}


//       {viewingLayout && (
//         <div className="modal-overlay" onClick={() => setViewingLayout(null)}>
//           <div className="modal-content1 modal-xl" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Layout Details</h3>
//               <button className="modal-close-btn" onClick={() => setViewingLayout(null)}>×</button>
//             </div>
//             <div className="modal-body">
//               {viewLoading ? (
//                 <div className="loading-container"><p>Loading layout details...</p></div>
//               ) : (
//                 <div className="layout-details">
//                   <div className="detail-header">
//                     <h4>{safeText(viewingLayout.name)}</h4>
//                     <div className="header-tags">
//                       <span className={`seat-type-badge ${viewingLayout.seatType}`}>{safeText(viewingLayout.seatType)}</span>
//                       <span className={`status-badge ${viewingLayout.isActive ? 'active' : 'inactive'}`}>{viewingLayout.isActive ? 'Active' : 'Inactive'}</span>
//                     </div>
//                   </div>
//                   <p className="description">{safeText(viewingLayout.description)}</p>
//                   <div className="layout-stats-grid">
//                     <div className="stat-card-sm"><h6>Total Seats</h6><p className="stat-number">{viewingLayout.totalSeats || 0}</p></div>
//                     <div className="stat-card-sm"><h6>Configuration</h6><p className="stat-number">{safeText(viewingLayout.configuration)}</p></div>
//                     <div className="stat-card-sm"><h6>Rows</h6><p className="stat-number">{viewingLayout.rows || 0}</p></div>
//                     <div className="stat-card-sm"><h6>Seats per Row</h6><p className="stat-number">{viewingLayout.seatsPerRow || 0}</p></div>
//                     <div className="stat-card-sm"><h6>Back Seats</h6><p className="stat-number">{viewingLayout.backSeats || 0}</p></div>
//                     <div className="stat-card-sm"><h6>Columns</h6><p className="stat-number">{viewingLayout.columns || 0}</p></div>
//                   </div>
//                   <div className="category-info"><h5>Category Information</h5><div className="category-detail"><strong>Category:</strong><span>{viewingLayout.category && typeof viewingLayout.category === 'object' ? viewingLayout.category.name || 'Unknown' : safeText(viewingLayout.category)}</span></div></div>
//                   {viewingLayout.seats && Array.isArray(viewingLayout.seats) && viewingLayout.seats.length > 0 && (
//                     <div className="seats-section"><h5>Seats Arrangement ({viewingLayout.seats.length} seats)</h5><div className="seats-grid">{viewingLayout.seats.slice(0, 50).map(seat => (<div key={seat.seatNumber} className="seat-item"><span className="seat-number">{seat.seatNumber}</span><span className="seat-info">Row: {seat.row}, Col: {seat.column}, Type: {seat.seatType}</span></div>))}{viewingLayout.seats.length > 50 && (<div className="more-seats">+ {viewingLayout.seats.length - 50} more seats...</div>)}</div></div>
//                   )}
//                   <div className="timestamps">
//                     {viewingLayout.createdAt && (<div className="timestamp"><strong>Created:</strong> {new Date(viewingLayout.createdAt).toLocaleString()}</div>)}
//                     {viewingLayout.updatedAt && (<div className="timestamp"><strong>Updated:</strong> {new Date(viewingLayout.updatedAt).toLocaleString()}</div>)}
//                     {viewingLayout.createdBy && (<div className="timestamp"><strong>Created By:</strong>{typeof viewingLayout.createdBy === 'object' ? viewingLayout.createdBy.name || 'Admin' : safeText(viewingLayout.createdBy)}</div>)}
//                   </div>
//                 </div>
//               )}
//             </div>
//             <div className="modal-footer">
//               <button className="modal-btn close" onClick={() => setViewingLayout(null)}>Close</button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default SeatManagement;

import React, { useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import '../../Styles/ManagementPages.css';
import '../../Styles/PrimaryRouteManage.css';   // base "prm-" design
import '../../Styles/PrimaryBusOwner.css';      // shared additions (avatar, pagination…)
import '../../Styles/CustomerReport.css';       // customer-only additions (load LAST)
import '../../Styles/SeatManagement.css';       // seat-specific previews
import {
  getAllSeatCategories,
  getSeatCategoryById,
  createSeatCategory,
  updateSeatCategory,
  deleteSeatCategory,
  getAllSeatLayouts,
  getSeatLayoutById,
  createSeatLayout,
  updateSeatLayout,
  deleteSeatLayout,
  previewSeatLayout,
  getAvailableConfigurations,
} from '../../Services/Operations/ProductAPI';
import { Icon, BusSvg, StatCard, Field, Avatar, Pagination } from './PrimaryUI';

// ---------- helpers ----------
const safeText = (value, fallback = 'N/A') => {
  if (value === null || value === undefined || value === '') return fallback;
  if (typeof value === 'object') return value.name ? value.name : JSON.stringify(value);
  return String(value);
};
const safeNum = (v) => (v === null || v === undefined ? 0 : Number(v) || 0);

// ============================================================
// Category card
// ============================================================
const CategoryCard = ({ category, index, onView, onEdit, onDelete, viewLoading }) => (
  <div className="prm-card cr-card" style={{ animationDelay: `${index * 60}ms` }}>
    <div className="prm-card-top">
      <div className="pbo-owner-id">
        <span className="prm-form-badge" style={{ width: 44, height: 44, fontSize: 16 }}>
          <Icon name="grid" size={20} />
        </span>
        <div>
          <div className="prm-card-no">Category #{String(category.serialNo).padStart(2, '0')}</div>
          <h3 className="prm-card-title">{safeText(category.name)}</h3>
          <div className="prm-card-sub">
            <Icon name="tag" size={14} /> {safeText(category.configuration)}
          </div>
        </div>
      </div>
      <span className={`prm-status ${category.isActive ? 'active' : 'inactive'}`}>
        {category.isActive ? 'Active' : 'Inactive'}
      </span>
    </div>

    <div className="pbo-contact">
      <div><Icon name="info" size={14} /> {safeText(category.description)}</div>
      <div><Icon name="grid" size={14} /> {category.layoutCount} layouts</div>
      <div><Icon name="bus" size={14} /> {category.leftSeats}L · {category.rightSeats}R · {category.totalSeatsPerRow}/row</div>
    </div>

    <div className="pbo-card-actions">
      <button className="prm-btn view sm" onClick={() => onView(category)} disabled={viewLoading}>
        <Icon name="eye" size={14} /> {viewLoading ? '…' : 'View'}
      </button>
      <button className="prm-btn ghost sm" onClick={(e) => onEdit(category, e)}>
        <Icon name="edit" size={14} /> Edit
      </button>
      <button className="prm-btn ghost sm" onClick={() => onDelete(category.id)} title="Delete">
        <Icon name="trash" size={14} />
      </button>
    </div>
  </div>
);

// ============================================================
// Layout card
// ============================================================
const LayoutCard = ({ layout, index, onView, onEdit, onDelete, viewLoading }) => (
  <div className="prm-card cr-card" style={{ animationDelay: `${index * 60}ms` }}>
    <div className="prm-card-top">
      <div className="pbo-owner-id">
        <span className="prm-form-badge" style={{ width: 44, height: 44, fontSize: 16 }}>
          <Icon name="bus" size={20} />
        </span>
        <div>
          <div className="prm-card-no">Layout #{String(layout.serialNo).padStart(2, '0')}</div>
          <h3 className="prm-card-title">{safeText(layout.name)}</h3>
          <div className="prm-card-sub">
            <Icon name="tag" size={14} /> {safeText(layout.seatType)}
          </div>
        </div>
      </div>
      <span className={`prm-status ${layout.isActive ? 'active' : 'inactive'}`}>
        {layout.isActive ? 'Active' : 'Inactive'}
      </span>
    </div>

    <div className="pbo-contact">
      <div><Icon name="info" size={14} /> {safeText(layout.description)}</div>
      <div><Icon name="grid" size={14} /> {safeText(layout.category)}</div>
      <div><Icon name="users" size={14} /> {layout.rows} rows · {layout.totalSeats} seats</div>
    </div>

    <div className="pbo-card-actions">
      <button className="prm-btn view sm" onClick={() => onView(layout)} disabled={viewLoading}>
        <Icon name="eye" size={14} /> {viewLoading ? '…' : 'View'}
      </button>
      <button className="prm-btn ghost sm" onClick={(e) => onEdit(layout, e)}>
        <Icon name="edit" size={14} /> Edit
      </button>
      <button className="prm-btn ghost sm" onClick={() => onDelete(layout.id)} title="Delete">
        <Icon name="trash" size={14} />
      </button>
    </div>
  </div>
);

// ============================================================
// MAIN
// ============================================================
const SeatManagement = () => {
  const { token } = useSelector(state => state.user);

  const [activeTab, setActiveTab] = useState('categories'); // categories | layouts
  const [loading, setLoading] = useState(true);
  const [firstLoad, setFirstLoad] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [searching, setSearching] = useState(false);
  const [layout, setLayout] = useState('table');

  const [categories, setCategories] = useState([]);
  const [showCategoryModal, setShowCategoryModal] = useState(false);
  const [editingCategory, setEditingCategory] = useState(null);
  const [categoryForm, setCategoryForm] = useState({ name: '', description: '', configuration: '' });
  const [categoryError, setCategoryError] = useState(null);
  const [savingCategory, setSavingCategory] = useState(false);

  const [layouts, setLayouts] = useState([]);
  const [showLayoutModal, setShowLayoutModal] = useState(false);
  const [editingLayout, setEditingLayout] = useState(null);
  const [layoutForm, setLayoutForm] = useState({
    name: '', description: '', category: '', seatType: 'seat', rows: 1
  });
  const [layoutError, setLayoutError] = useState(null);
  const [layoutPreview, setLayoutPreview] = useState(null);
  const [loadingPreview, setLoadingPreview] = useState(false);
  const [savingLayout, setSavingLayout] = useState(false);
  const [availableConfigurations, setAvailableConfigurations] = useState([]);

  const [viewingCategory, setViewingCategory] = useState(null);
  const [viewingLayout, setViewingLayout] = useState(null);
  const [viewLoading, setViewLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));

  // ---------- fetch ----------
  useEffect(() => {
    const t = setTimeout(() => {
      if (activeTab === 'categories') fetchCategories();
      else fetchLayouts();
    }, 400);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, pageSize, searchTerm, activeTab]);

  useEffect(() => { fetchConfigurations(); }, []); // eslint-disable-line

  useEffect(() => { if (currentPage > totalPages) setCurrentPage(totalPages); }, [currentPage, totalPages]);

  const fetchConfigurations = async () => {
    try {
      const response = await getAvailableConfigurations(token);
      if (response?.success) setAvailableConfigurations(response.data || []);
    } catch (error) { console.error('Error fetching configurations:', error); }
  };

  const fetchCategories = async () => {
    try {
      setSearching(true);
      setLoading(true);
      const response = await getAllSeatCategories(token, currentPage, pageSize, searchTerm);
      if (response && response.data) {
        const transformed = response.data.map((c, index) => ({
          id: String(c._id || ''),
          serialNo: (currentPage - 1) * pageSize + index + 1,
          name: String(c.name || ''),
          description: String(c.description || ''),
          configuration: String(c.configuration || ''),
          leftSeats: Number(c.leftSeats || 0),
          rightSeats: Number(c.rightSeats || 0),
          totalSeatsPerRow: Number(c.totalSeatsPerRow || 0),
          layoutCount: Number(c.layoutCount || 0),
          isActive: Boolean(c.isActive || false),
          rawData: c
        }));
        setCategories(transformed);
        setTotalItems(response.total || transformed.length);
      }
    } catch (error) {
      console.error('Error fetching categories:', error);
      toast.error('Failed to load categories');
    } finally {
      setLoading(false);
      setSearching(false);
      setFirstLoad(false);
    }
  };

  const fetchLayouts = async () => {
    try {
      setSearching(true);
      setLoading(true);
      const response = await getAllSeatLayouts(token, currentPage, pageSize, searchTerm);
      if (response && response.data) {
        const transformed = response.data.map((l, index) => {
          let categoryName = 'Unknown';
          let categoryId = '';
          if (l.category) {
            if (typeof l.category === 'object') {
              categoryName = String(l.category.name || 'Unknown');
              categoryId = l.category._id || '';
            } else {
              categoryName = String(l.category);
              categoryId = String(l.category || '');
            }
          }
          return {
            id: String(l._id || ''),
            serialNo: (currentPage - 1) * pageSize + index + 1,
            name: String(l.name || ''),
            description: String(l.description || ''),
            category: categoryName,
            categoryId,
            configuration: String(l.configuration || ''),
            seatType: String(l.seatType || 'seat'),
            rows: Number(l.rows || 0),
            totalSeats: Number(l.totalSeats || 0),
            isActive: Boolean(l.isActive || false),
            rawData: l
          };
        });
        setLayouts(transformed);
        setTotalItems(response.total || transformed.length);
      }
    } catch (error) {
      console.error('Error fetching layouts:', error);
      toast.error('Failed to load layouts');
    } finally {
      setLoading(false);
      setSearching(false);
      setFirstLoad(false);
    }
  };

  // ---------- view / create / edit / delete ----------
  const handleViewCategory = async (category) => {
    try {
      setViewLoading(true);
      setViewingCategory(category.rawData || category);
      const response = await getSeatCategoryById(category.id, token);
      if (response?.success) setViewingCategory(response.data);
    } catch (error) {
      console.error('Error viewing category:', error);
    } finally {
      setViewLoading(false);
    }
  };

  const handleViewLayout = async (layout) => {
    try {
      setViewLoading(true);
      setViewingLayout(layout.rawData || layout);
      const response = await getSeatLayoutById(layout.id, token);
      if (response?.success) setViewingLayout(response.data);
    } catch (error) {
      console.error('Error viewing layout:', error);
    } finally {
      setViewLoading(false);
    }
  };

  const handleCreateCategory = (e) => {
    if (e) e.stopPropagation();
    setEditingCategory(null);
    setCategoryForm({ name: '', description: '', configuration: '' });
    setCategoryError(null);
    setShowCategoryModal(true);
  };

  const handleEditCategory = (category, e) => {
    if (e) e.stopPropagation();
    setEditingCategory(category.id);
    setCategoryForm({
      name: String(category.name || ''),
      description: String(category.description || ''),
      configuration: String(category.configuration || '')
    });
    setCategoryError(null);
    setShowCategoryModal(true);
  };

  const handleSaveCategory = async () => {
    try {
      setCategoryError(null);
      if (!categoryForm.name || !categoryForm.description || !categoryForm.configuration) {
        return setCategoryError('All fields are required');
      }
      setSavingCategory(true);
      const response = editingCategory
        ? await updateSeatCategory(editingCategory, categoryForm, token)
        : await createSeatCategory(categoryForm, token);
      if (response.success) {
        await fetchCategories();
        setShowCategoryModal(false);
        toast.success(`Category ${editingCategory ? 'updated' : 'created'} successfully`);
      } else {
        setCategoryError(response.message || 'Failed to save category');
      }
    } catch (error) {
      console.error('Error saving category:', error);
      setCategoryError(error.message || 'An error occurred');
    } finally {
      setSavingCategory(false);
    }
  };

  const handleDeleteCategory = async (id) => {
    if (!window.confirm('Are you sure you want to delete this category?')) return;
    try {
      const response = await deleteSeatCategory(id, token);
      if (response.success) {
        await fetchCategories();
        toast.success('Category deleted successfully');
      } else {
        toast.error(response.message || 'Failed to delete category');
      }
    } catch (error) {
      console.error('Error deleting category:', error);
      toast.error('Error deleting category');
    }
  };

  const handleCreateLayout = (e) => {
    if (e) e.stopPropagation();
    setEditingLayout(null);
    setLayoutForm({ name: '', description: '', category: '', seatType: 'seat', rows: 1 });
    setLayoutError(null);
    setLayoutPreview(null);
    setShowLayoutModal(true);
  };

  const handleEditLayout = (layout, e) => {
    if (e) e.stopPropagation();
    setEditingLayout(layout.id);
    setLayoutForm({
      name: String(layout.name || ''),
      description: String(layout.description || ''),
      category: String(layout.categoryId || ''),
      seatType: String(layout.seatType || 'seat'),
      rows: Number(layout.rows || 1)
    });
    setLayoutError(null);
    setLayoutPreview(null);
    setShowLayoutModal(true);
  };

  const handleGeneratePreview = async () => {
    try {
      if (!layoutForm.category || !layoutForm.seatType || layoutForm.rows < 1) {
        return setLayoutError('Please fill all required fields');
      }
      setLoadingPreview(true);
      const previewData = {
        category: layoutForm.category,
        seatType: layoutForm.seatType,
        rows: parseInt(layoutForm.rows),
        basePrice: 1200
      };
      const response = await previewSeatLayout(previewData, token);
      if (response.success) setLayoutPreview(response.data);
      else setLayoutError(response.message || 'Failed to generate preview');
    } catch (error) {
      setLayoutError(error.message || 'Error generating preview');
    } finally {
      setLoadingPreview(false);
    }
  };

  const handleSaveLayout = async () => {
    try {
      setLayoutError(null);
      if (!layoutPreview) return setLayoutError('Please generate a preview first');
      if (!layoutForm.name || !layoutForm.description) return setLayoutError('Name and description are required');

      setSavingLayout(true);
      const layoutData = {
        name: layoutForm.name,
        description: layoutForm.description,
        category: layoutForm.category,
        seatType: layoutForm.seatType,
        rows: parseInt(layoutForm.rows)
      };
      const response = editingLayout
        ? await updateSeatLayout(editingLayout, layoutData, token)
        : await createSeatLayout(layoutData, token);

      if (response.success) {
        await fetchLayouts();
        setShowLayoutModal(false);
        toast.success(`Layout ${editingLayout ? 'updated' : 'created'} successfully`);
      } else {
        setLayoutError(response.message || 'Failed to save layout');
      }
    } catch (error) {
      console.error('Error saving layout:', error);
      setLayoutError(error.message || 'An error occurred');
    } finally {
      setSavingLayout(false);
    }
  };

  const handleDeleteLayout = async (id) => {
    if (!window.confirm('Are you sure you want to delete this layout?')) return;
    try {
      const response = await deleteSeatLayout(id, token);
      if (response.success) {
        await fetchLayouts();
        toast.success('Layout deleted successfully');
      } else {
        toast.error(response.message || 'Failed to delete layout');
      }
    } catch (error) {
      console.error('Error deleting layout:', error);
      toast.error('Error deleting layout');
    }
  };

  const handleRefresh = () => {
    setSearchTerm('');
    setCurrentPage(1);
    if (activeTab === 'categories') fetchCategories(); else fetchLayouts();
  };

  const handleExportCSV = () => {
    const data = activeTab === 'categories' ? categories : layouts;
    if (data.length === 0) return toast.warning('No data to export');

    let headers, rows;
    if (activeTab === 'categories') {
      headers = ['No.', 'Name', 'Configuration', 'Left Seats', 'Right Seats', 'Total/Row', 'Layouts', 'Status'];
      rows = data.map(i => [i.serialNo, i.name, i.configuration, i.leftSeats, i.rightSeats, i.totalSeatsPerRow, i.layoutCount, i.isActive ? 'Active' : 'Inactive']);
    } else {
      headers = ['No.', 'Name', 'Category', 'Seat Type', 'Configuration', 'Rows', 'Total Seats', 'Status'];
      rows = data.map(i => [i.serialNo, i.name, i.category, i.seatType, i.configuration, i.rows, i.totalSeats, i.isActive ? 'Active' : 'Inactive']);
    }
    const csv = [headers.join(','), ...rows.map(r => r.map(f => `"${String(f ?? '').replace(/"/g, '""')}"`).join(','))].join('\n');
    const url = window.URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8;' }));
    const a = document.createElement('a');
    a.href = url;
    a.download = `${activeTab}-report-${new Date().toISOString().split('T')[0]}.csv`;
    document.body.appendChild(a); a.click(); document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
    toast.success('CSV exported successfully');
  };

  // ---------- preview renderer ----------
  const renderSeatPreview = () => {
    if (!layoutPreview || !layoutPreview.seatPreview) return null;
    const { seatPreview, totalRows, seatsPerRow, configuration, totalSeats, backSeats } = layoutPreview;

    const seatsByRow = {};
    seatPreview.forEach(seat => {
      if (!seatsByRow[seat.row]) seatsByRow[seat.row] = [];
      seatsByRow[seat.row].push(seat);
    });
    const sortedRows = Object.keys(seatsByRow).sort((a, b) => Number(a) - Number(b));
    const [leftCount, rightCount] = configuration.split('*').map(Number);

    return (
      <div className="preview-container">
        <h4>Seat Layout Preview</h4>
        <div className="seat-preview-grid">
          {sortedRows.map(rowNum => {
            const isBackRow = rowNum > totalRows - (backSeats / seatsPerRow);
            const rowSeats = seatsByRow[rowNum].sort((a, b) => a.column - b.column);
            const leftSeats = rowSeats.filter(s => s.position === 'left');
            const rightSeats = rowSeats.filter(s => s.position === 'right' || s.position === 'middle');
            return (
              <div key={rowNum} className={`preview-row ${isBackRow ? 'back-row' : ''}`}>
                <div className="row-label">{isBackRow ? 'Back Row' : `Row ${rowNum}`}</div>
                <div className="row-seats">
                  <div className="seat-group left-group">
                    {leftSeats.map(seat => (
                      <div key={seat.seatNumber} className="preview-seat left" title={`${seat.seatNumber} - Left`}>
                        <span className="seat-number">{seat.seatNumber}</span>
                      </div>
                    ))}
                  </div>
                  <div className="aisle-space"><span className="aisle-label">Aisle</span></div>
                  <div className="seat-group right-group">
                    {rightSeats.map(seat => (
                      <div key={seat.seatNumber} className="preview-seat right" title={`${seat.seatNumber} - Right`}>
                        <span className="seat-number">{seat.seatNumber}</span>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="row-summary">
                  <span className="left-count">{leftSeats.length}L</span>
                  <span className="right-count">{rightSeats.length}R</span>
                </div>
              </div>
            );
          })}
        </div>
        <div className="preview-legend">
          <div className="legend-item"><div className="legend-color left-seat"></div><span>Left Seat ({leftCount} per row)</span></div>
          <div className="legend-item"><div className="legend-color right-seat"></div><span>Right Seat ({rightCount} per row)</span></div>
          <div className="legend-item"><div className="legend-color back-seat"></div><span>Back Row Seats</span></div>
          <div className="legend-item"><div className="legend-color aisle"></div><span>Aisle (Center)</span></div>
        </div>
      </div>
    );
  };

  const currentData = activeTab === 'categories' ? categories : layouts;
  const activeCount = currentData.filter(i => i.isActive).length;

  // ============================================================
  if (firstLoad && loading) {
    return (
      <div className="prm-page">
        <div className="prm-hero"><div className="prm-hero-text">
          <span className="prm-eyebrow"><Icon name="grid" size={13} /> Seats</span>
          <h1>Seat Management</h1><p>Loading seat data…</p>
        </div></div>
        <div style={{ height: 24 }} />
        <div className="prm-grid">
          {[0, 1, 2].map(i => (
            <div className="prm-skel" key={i}>
              <div className="w40" /><div className="w60" /><div className="big" /><div /><div className="w60" />
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="prm-page">
      {/* HERO */}
      <div className="prm-hero">
        <div className="prm-hero-road" aria-hidden="true">
          <span className="prm-hero-roadbus"><BusSvg size={46} /></span>
        </div>
        <div className="prm-hero-text">
          <span className="prm-eyebrow"><Icon name="grid" size={13} /> Fleet Configuration</span>
          <h1>Seat Management</h1>
          <p>Define seat categories and generate detailed bus layouts with live previews.</p>
        </div>
        <div className="prm-hero-actions">
          <div className="prm-search">
            <Icon name="search" size={17} />
            <input
              type="text"
              placeholder={`Search ${activeTab}…`}
              value={searchTerm}
              onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }}
            />
            {searchTerm && (
              <button className="prm-search-clear" onClick={() => { setSearchTerm(''); setCurrentPage(1); }}>×</button>
            )}
          </div>
          <button className="pbo-icon-btn" onClick={handleRefresh} title="Refresh">
            <Icon name="refresh" size={17} />
          </button>
          <button className="pbo-icon-btn" onClick={handleExportCSV} title="Export CSV">
            <Icon name="download" size={17} />
          </button>
          <button
            className="prm-add-btn"
            onClick={activeTab === 'categories' ? handleCreateCategory : handleCreateLayout}
          >
            <span className="plus"><Icon name="plus" size={14} /></span>
            New {activeTab === 'categories' ? 'Category' : 'Layout'}
          </button>
        </div>
      </div>

      {/* TABS */}
      <div className="prm-chips" style={{ marginBottom: 16 }}>
        <button
          className={`prm-chip ${activeTab === 'categories' ? 'active' : ''}`}
          onClick={() => { setActiveTab('categories'); setCurrentPage(1); }}
        >
          <Icon name="grid" size={14} /> Seat Categories <span className="count">{activeTab === 'categories' ? totalItems : ''}</span>
        </button>
        <button
          className={`prm-chip ${activeTab === 'layouts' ? 'active' : ''}`}
          onClick={() => { setActiveTab('layouts'); setCurrentPage(1); }}
        >
          <Icon name="bus" size={14} /> Seat Layouts <span className="count">{activeTab === 'layouts' ? totalItems : ''}</span>
        </button>
      </div>

      {/* STATS */}
      <div className="prm-stats">
        <StatCard
          icon={activeTab === 'categories' ? 'grid' : 'bus'}
          tone="indigo"
          label={`Total ${activeTab === 'categories' ? 'Categories' : 'Layouts'}`}
          value={totalItems}
          hint={`All ${activeTab} in system`}
          delay={80}
        />
        <StatCard icon="check" tone="green" label="Active" value={activeCount} hint="Currently active (page)" delay={160} />
        {activeTab === 'categories' ? (
          <>
            <StatCard icon="bus" tone="cyan" label="Total Layouts" value={categories.reduce((s, c) => s + safeNum(c.layoutCount), 0)} hint="Across all categories (page)" delay={240} />
            <StatCard icon="search" tone="amber" label="Search Results" value={categories.length} hint="Categories on this page" delay={320} />
          </>
        ) : (
          <>
            <StatCard icon="tag" tone="cyan" label="Seat Types" value={[...new Set(layouts.map(l => l.seatType))].length} hint="Distinct types (page)" delay={240} />
            <StatCard icon="users" tone="amber" label="Total Seats" value={layouts.reduce((s, l) => s + safeNum(l.totalSeats), 0)} hint="Across layouts (page)" delay={320} />
          </>
        )}
      </div>

      {/* TOOLBAR */}
      <div className="prm-toolbar">
        <div className="prm-toolbar-left">
          <div className="prm-chips">
            <button className="prm-chip active">
              {activeTab === 'categories' ? 'Categories' : 'Layouts'} <span className="count">{currentData.length}</span>
            </button>
          </div>
          {searchTerm && <span className="prm-tag amber">Search: “{searchTerm}”</span>}
          {searching && <span className="prm-tag gray">searching…</span>}
        </div>
        <div className="prm-toolbar-right">
          <span className="prm-result-count">Showing <b>{currentData.length}</b> of {totalItems}</span>
          <div className="prm-layout-toggle">
            <button className={layout === 'cards' ? 'active' : ''} onClick={() => setLayout('cards')} title="Card view">
              <Icon name="grid" size={17} />
            </button>
            <button className={layout === 'table' ? 'active' : ''} onClick={() => setLayout('table')} title="Table view">
              <Icon name="list" size={17} />
            </button>
          </div>
        </div>
      </div>

      {/* LIST */}
      <div className={loading && currentData.length > 0 ? 'cr-loading' : ''}>
        {currentData.length === 0 && !loading ? (
          <div className="prm-empty">
            <div className="icon"><Icon name={searchTerm ? 'search' : (activeTab === 'categories' ? 'grid' : 'bus')} size={44} /></div>
            <h3>{searchTerm ? `No ${activeTab} match your search` : `No ${activeTab} yet`}</h3>
            <p>{searchTerm ? 'Try a different search term.' : `Click “New ${activeTab === 'categories' ? 'Category' : 'Layout'}” to get started.`}</p>
            {searchTerm && <button className="prm-btn ghost" onClick={handleRefresh}>Clear search</button>}
          </div>
        ) : layout === 'cards' ? (
          <div className="prm-grid">
            {activeTab === 'categories'
              ? categories.map((cat, i) => (
                  <CategoryCard
                    key={cat.id} category={cat} index={i}
                    onView={handleViewCategory} onEdit={handleEditCategory}
                    onDelete={handleDeleteCategory} viewLoading={viewLoading}
                  />
                ))
              : layouts.map((l, i) => (
                  <LayoutCard
                    key={l.id} layout={l} index={i}
                    onView={handleViewLayout} onEdit={handleEditLayout}
                    onDelete={handleDeleteLayout} viewLoading={viewLoading}
                  />
                ))}
          </div>
        ) : (
          <div className="prm-table-wrap">
            {activeTab === 'categories' ? (
              <table className="prm-table">
                <thead>
                  <tr>
                    <th>No.</th><th>Name</th><th>Configuration</th><th>Layouts</th><th>Status</th><th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {categories.map((c, i) => (
                    <tr key={c.id} style={{ animationDelay: `${i * 50}ms` }}>
                      <td>{c.serialNo}</td>
                      <td>
                        <div className="name">{safeText(c.name)}</div>
                        <div className="sub">{safeText(c.description)}</div>
                      </td>
                      <td><span className="prm-tag gray">{safeText(c.configuration)}</span></td>
                      <td><span className="pbo-count">{c.layoutCount}</span></td>
                      <td><span className={`prm-status ${c.isActive ? 'active' : 'inactive'}`}>{c.isActive ? 'Active' : 'Inactive'}</span></td>
                      <td>
                        <div className="prm-row-actions">
                          <button className="prm-btn view sm icon-only" onClick={() => handleViewCategory(c)} disabled={viewLoading} title="View" aria-label="View"><Icon name="eye" size={13} /></button>
                          <button className="prm-btn ghost sm icon-only" onClick={(e) => handleEditCategory(c, e)} title="Edit" aria-label="Edit"><Icon name="edit" size={13} /></button>
                          <button className="prm-btn ghost sm icon-only" onClick={() => handleDeleteCategory(c.id)} title="Delete"><Icon name="trash" size={13} /></button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <table className="prm-table">
                <thead>
                  <tr>
                    <th>No.</th><th>Name</th><th>Category</th><th>Seat Type</th><th>Total Seats</th><th>Status</th><th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {layouts.map((l, i) => (
                    <tr key={l.id} style={{ animationDelay: `${i * 50}ms` }}>
                      <td>{l.serialNo}</td>
                      <td>
                        <div className="name">{safeText(l.name)}</div>
                        <div className="sub">{safeText(l.description)}</div>
                      </td>
                      <td>{safeText(l.category)}</td>
                      <td><span className="prm-tag gray">{safeText(l.seatType)}</span></td>
                      <td><span className="pbo-count">{l.totalSeats}</span></td>
                      <td><span className={`prm-status ${l.isActive ? 'active' : 'inactive'}`}>{l.isActive ? 'Active' : 'Inactive'}</span></td>
                      <td>
                        <div className="prm-row-actions">
                          <button className="prm-btn view sm icon-only" onClick={() => handleViewLayout(l)} disabled={viewLoading} title="View" aria-label="View"><Icon name="eye" size={13} /></button>
                          <button className="prm-btn ghost sm icon-only" onClick={(e) => handleEditLayout(l, e)} title="Edit" aria-label="Edit"><Icon name="edit" size={13} /></button>
                          <button className="prm-btn ghost sm icon-only" onClick={() => handleDeleteLayout(l.id)} title="Delete"><Icon name="trash" size={13} /></button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        )}
      </div>

      {/* PAGINATION */}
      <Pagination
        page={currentPage} pageSize={pageSize} total={totalItems}
        onPage={(p) => setCurrentPage(Math.min(Math.max(1, p), totalPages))}
        onPageSize={(s) => { setPageSize(s); setCurrentPage(1); }}
        sizes={[10, 25, 50, 100]}
        label={activeTab}
      />

      {/* CATEGORY MODAL */}
      {showCategoryModal && (
        <div className="prm-overlay" onClick={() => setShowCategoryModal(false)}>
          <div className="prm-form-modal prm-form-modal-sm" onClick={(e) => e.stopPropagation()}>
            <div className="prm-form-head">
              <div className="prm-form-head-row">
                <span className="prm-form-badge"><Icon name={editingCategory ? 'edit' : 'plus'} size={22} /></span>
                <div>
                  <h3>{editingCategory ? 'Edit category' : 'Create new category'}</h3>
                  <p>Define seat configuration</p>
                </div>
              </div>
              <button className="prm-modal-close" onClick={() => setShowCategoryModal(false)}>×</button>
            </div>
            <div className="prm-form-body">
              {categoryError && <div className="cr-error" style={{ marginBottom: 12 }}><Icon name="info" size={16} /> {categoryError}</div>}
              <div className="prm-fgrid">
                <Field label="Category Name" required full>
                  <input className="prm-input" value={categoryForm.name}
                    onChange={(e) => setCategoryForm({ ...categoryForm, name: e.target.value })}
                    placeholder="e.g., Standard 2x2 Layout" />
                </Field>
                <Field label="Description" required full>
                  <textarea className="prm-input" rows="3" value={categoryForm.description}
                    onChange={(e) => setCategoryForm({ ...categoryForm, description: e.target.value })}
                    placeholder="Describe this seat configuration" />
                </Field>
                <Field label="Configuration" required full note="Format: leftSeats*rightSeats (e.g. 2*2, 3*2, 4*3)">
                  <input className="prm-input" value={categoryForm.configuration}
                    onChange={(e) => setCategoryForm({ ...categoryForm, configuration: e.target.value })}
                    placeholder="e.g., 2*2" />
                </Field>
              </div>
            </div>
            <div className="prm-form-foot">
              <span className="prm-foot-hint">Fields marked <em>*</em> are required</span>
              <div className="prm-form-foot-actions">
                <button className="prm-btn ghost" onClick={() => setShowCategoryModal(false)} disabled={savingCategory}>Cancel</button>
                <button className="prm-btn primary" onClick={handleSaveCategory} disabled={savingCategory}>
                  {savingCategory ? 'Saving…' : (editingCategory ? 'Update category' : 'Create category')}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* LAYOUT MODAL */}
      {showLayoutModal && (
        <div className="prm-overlay" onClick={() => setShowLayoutModal(false)}>
          <div className="prm-form-modal" style={{ maxWidth: 820 }} onClick={(e) => e.stopPropagation()}>
            <div className="prm-form-head">
              <div className="prm-form-head-row">
                <span className="prm-form-badge"><Icon name={editingLayout ? 'edit' : 'plus'} size={22} /></span>
                <div>
                  <h3>{editingLayout ? 'Edit layout' : 'Create new layout'}</h3>
                  <p>Configure rows and preview seat arrangement</p>
                </div>
              </div>
              <button className="prm-modal-close" onClick={() => setShowLayoutModal(false)}>×</button>
            </div>
            <div className="prm-form-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
              {layoutError && <div className="cr-error" style={{ marginBottom: 12 }}><Icon name="info" size={16} /> {layoutError}</div>}
              <div className="prm-fgrid">
                <Field label="Layout Name" required>
                  <input className="prm-input" value={layoutForm.name}
                    onChange={(e) => setLayoutForm({ ...layoutForm, name: e.target.value })}
                    placeholder="e.g., Economy 2x2 Bus" />
                </Field>
                <Field label="Description" required>
                  <input className="prm-input" value={layoutForm.description}
                    onChange={(e) => setLayoutForm({ ...layoutForm, description: e.target.value })}
                    placeholder="e.g., Economy class with regular seats" />
                </Field>
                <Field label="Category" required>
                  <select className="prm-input prm-select" value={layoutForm.category}
                    onChange={(e) => setLayoutForm({ ...layoutForm, category: e.target.value })}>
                    <option value="">Select Category</option>
                    {categories.map(cat => (
                      <option key={cat.id} value={cat.id}>{cat.name} ({cat.configuration})</option>
                    ))}
                  </select>
                </Field>
                <Field label="Seat Type" required>
                  <select className="prm-input prm-select" value={layoutForm.seatType}
                    onChange={(e) => setLayoutForm({ ...layoutForm, seatType: e.target.value })}>
                    <option value="seat">Regular Seat</option>
                    <option value="sleeper">Sleeper</option>
                    <option value="seater+sleeper">Seat + Sleeper</option>
                  </select>
                </Field>
                <Field label="Number of Rows" required full>
                  <input type="number" min="1" className="prm-input" value={layoutForm.rows}
                    onChange={(e) => setLayoutForm({ ...layoutForm, rows: parseInt(e.target.value) || 1 })} />
                </Field>
              </div>

              <div style={{ marginTop: 12, display: 'flex', gap: 8 }}>
                <button
                  className="prm-btn primary"
                  onClick={handleGeneratePreview}
                  disabled={loadingPreview || !layoutForm.category || !layoutForm.seatType}
                >
                  <Icon name="refresh" size={15} /> {loadingPreview ? 'Generating…' : 'Generate Preview'}
                </button>
              </div>

              {layoutPreview && <div style={{ marginTop: 16 }}>{renderSeatPreview()}</div>}
            </div>
            <div className="prm-form-foot">
              <span className="prm-foot-hint">
                {layoutPreview ? 'Preview generated — ready to save' : 'Generate a preview before saving'}
              </span>
              <div className="prm-form-foot-actions">
                <button className="prm-btn ghost" onClick={() => setShowLayoutModal(false)} disabled={savingLayout}>Cancel</button>
                <button className="prm-btn primary" onClick={handleSaveLayout} disabled={!layoutPreview || savingLayout}>
                  {savingLayout ? 'Saving…' : (editingLayout ? 'Update layout' : 'Create layout')}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* VIEW CATEGORY MODAL */}
      {viewingCategory && (
        <div className="prm-overlay" onClick={() => setViewingCategory(null)}>
          <div className="prm-form-modal" style={{ maxWidth: 720 }} onClick={(e) => e.stopPropagation()}>
            <div className="prm-form-head">
              <div className="prm-form-head-row">
                <span className="prm-form-badge"><Icon name="grid" size={22} /></span>
                <div>
                  <h3>{safeText(viewingCategory.name)}</h3>
                  <p>Category details</p>
                </div>
              </div>
              <button className="prm-modal-close" onClick={() => setViewingCategory(null)}>×</button>
            </div>
            <div className="prm-form-body">
              {viewLoading ? (
                <p>Loading…</p>
              ) : (
                <>
                  <div className="pbo-mini-stats">
                    <div><span>Configuration</span><b>{safeText(viewingCategory.configuration)}</b></div>
                    <div><span>Status</span><b className={viewingCategory.isActive ? 'cr-ok' : 'cr-off'}>{viewingCategory.isActive ? 'Active' : 'Inactive'}</b></div>
                    <div><span>Left Seats</span><b>{viewingCategory.leftSeats || 0}</b></div>
                    <div><span>Right Seats</span><b>{viewingCategory.rightSeats || 0}</b></div>
                    <div><span>Total per Row</span><b>{viewingCategory.totalSeatsPerRow || 0}</b></div>
                    <div><span>Layout Count</span><b>{viewingCategory.layoutCount || 0}</b></div>
                    <div><span>Available Types</span><b>{Array.isArray(viewingCategory.availableSeatTypes) ? viewingCategory.availableSeatTypes.join(', ') : 'N/A'}</b></div>
                    {viewingCategory.createdAt && (
                      <div><span>Created</span><b>{new Date(viewingCategory.createdAt).toLocaleDateString()}</b></div>
                    )}
                    {viewingCategory.updatedAt && (
                      <div><span>Updated</span><b>{new Date(viewingCategory.updatedAt).toLocaleDateString()}</b></div>
                    )}
                  </div>

                  <p style={{ marginTop: 12, color: '#4a5568' }}>{safeText(viewingCategory.description)}</p>

                  {viewingCategory.configuration && (
                    <>
                      <div className="prm-section-title">Configuration preview</div>
                      <div className="seat-visualization">
                        <div className="seat-row">
                          {Array.from({ length: viewingCategory.leftSeats || 0 }).map((_, i) => (
                            <div key={`left-${i}`} className="seat left">L{i + 1}</div>
                          ))}
                          <div className="aisle">Aisle</div>
                          {Array.from({ length: viewingCategory.rightSeats || 0 }).map((_, i) => (
                            <div key={`right-${i}`} className="seat right">R{i + 1}</div>
                          ))}
                        </div>
                      </div>
                    </>
                  )}
                </>
              )}
            </div>
            <div className="prm-form-foot">
              <span />
              <div className="prm-form-foot-actions">
                <button className="prm-btn primary" onClick={() => setViewingCategory(null)}>Close</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* VIEW LAYOUT MODAL */}
      {viewingLayout && (
        <div className="prm-overlay" onClick={() => setViewingLayout(null)}>
          <div className="prm-form-modal" style={{ maxWidth: 900, maxHeight: '85vh', overflow: 'hidden' }} onClick={(e) => e.stopPropagation()}>
            <div className="prm-form-head">
              <div className="prm-form-head-row">
                <span className="prm-form-badge"><Icon name="bus" size={22} /></span>
                <div>
                  <h3>{safeText(viewingLayout.name)}</h3>
                  <p>Layout details</p>
                </div>
              </div>
              <button className="prm-modal-close" onClick={() => setViewingLayout(null)}>×</button>
            </div>
            <div className="prm-form-body" style={{ maxHeight: '65vh', overflowY: 'auto' }}>
              {viewLoading ? (
                <p>Loading…</p>
              ) : (
                <>
                  <div className="pbo-mini-stats">
                    <div><span>Seat Type</span><b>{safeText(viewingLayout.seatType)}</b></div>
                    <div><span>Status</span><b className={viewingLayout.isActive ? 'cr-ok' : 'cr-off'}>{viewingLayout.isActive ? 'Active' : 'Inactive'}</b></div>
                    <div><span>Total Seats</span><b>{viewingLayout.totalSeats || 0}</b></div>
                    <div><span>Configuration</span><b>{safeText(viewingLayout.configuration)}</b></div>
                    <div><span>Rows</span><b>{viewingLayout.rows || 0}</b></div>
                    <div><span>Seats / Row</span><b>{viewingLayout.seatsPerRow || 0}</b></div>
                    <div><span>Back Seats</span><b>{viewingLayout.backSeats || 0}</b></div>
                    <div><span>Columns</span><b>{viewingLayout.columns || 0}</b></div>
                    <div>
                      <span>Category</span>
                      <b>{viewingLayout.category && typeof viewingLayout.category === 'object' ? viewingLayout.category.name || 'Unknown' : safeText(viewingLayout.category)}</b>
                    </div>
                  </div>

                  <p style={{ marginTop: 12, color: '#4a5568' }}>{safeText(viewingLayout.description)}</p>

                  {viewingLayout.seats && Array.isArray(viewingLayout.seats) && viewingLayout.seats.length > 0 && (
                    <>
                      <div className="prm-section-title">Seats arrangement ({viewingLayout.seats.length})</div>
                      <div className="prm-table-wrap" style={{ maxHeight: 260, overflowY: 'auto' }}>
                        <table className="prm-table">
                          <thead>
                            <tr><th>Seat</th><th>Row</th><th>Col</th><th>Type</th></tr>
                          </thead>
                          <tbody>
                            {viewingLayout.seats.slice(0, 50).map(seat => (
                              <tr key={seat.seatNumber}>
                                <td><b>{seat.seatNumber}</b></td>
                                <td>{seat.row}</td>
                                <td>{seat.column}</td>
                                <td>{seat.seatType}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      {viewingLayout.seats.length > 50 && (
                        <p style={{ textAlign: 'center', marginTop: 10, color: '#718096', fontSize: 13 }}>
                          +{viewingLayout.seats.length - 50} more seats…
                        </p>
                      )}
                    </>
                  )}

                  <div className="prm-section-title">Timestamps</div>
                  <div className="pbo-mini-stats">
                    {viewingLayout.createdAt && <div><span>Created</span><b>{new Date(viewingLayout.createdAt).toLocaleString()}</b></div>}
                    {viewingLayout.updatedAt && <div><span>Updated</span><b>{new Date(viewingLayout.updatedAt).toLocaleString()}</b></div>}
                    {viewingLayout.createdBy && (
                      <div>
                        <span>Created By</span>
                        <b>{typeof viewingLayout.createdBy === 'object' ? viewingLayout.createdBy.name || 'Admin' : safeText(viewingLayout.createdBy)}</b>
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>
            <div className="prm-form-foot">
              <span />
              <div className="prm-form-foot-actions">
                <button className="prm-btn primary" onClick={() => setViewingLayout(null)}>Close</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SeatManagement;